import React, { useRef } from 'react';

import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').FourImages}
 */
const FourImages = ({
    image1,
    image2,
    image3,
    image4,
    video1,
    video2,
    video3,
    video4,
    caption1,
    caption2,
    caption3,
    caption4
}) => {
    const image1Ref = useRef(null);
    const image2Ref = useRef(null);
    const image3Ref = useRef(null);
    const image4Ref = useRef(null);

    return (
        <>
            <div
                className='flex flex-col sm-flex-row width-100'>
                <figure
                    className={`col-12 flex flex-wrap flex-grow ${video1 ? 'sm-width-min-content' : 'sm-width-auto'} mb4 sm-mb3 sm-mr5 md-mr6`}
                    ref={image1Ref}>
                    {video1 ? (
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='height-100 width-100 object-cover'
                            src={video1.videoUrl}/>
                    ) : (
                        <Image
                            {...image1}
                            height={1440}
                            width={960} />
                    )}
                    {caption1 && (
                        <figcaption className='pt3 sm-hide'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption1}}/>
                        </figcaption>
                    )}
                </figure>
                <figure
                    className={`col-12 flex flex-wrap flex-grow ${video2 ? 'sm-width-min-content' : 'sm-width-auto'} mb4 sm-mb3 sm-mr5 md-mr6`}
                    ref={image2Ref}>
                    {video2 ? (
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='height-100 width-100 object-cover'
                            src={video2.videoUrl}/>
                    ) : (
                        <Image
                            {...image2}
                            height={1440}
                            width={960} />
                    )}
                    {caption2 && (
                        <figcaption className='pt3 sm-hide'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption2}}/>
                        </figcaption>
                    )}
                </figure>
                <figure
                    className={`col-12 flex flex-wrap flex-grow ${video3 ? 'sm-width-min-content' : 'sm-width-auto'} mb4 sm-mb3 sm-mr5 md-mr6`}
                    ref={image3Ref}>
                    {video3 ? (
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='height-100 width-100 object-cover'
                            src={video3.videoUrl}/>
                    ) : (
                        <Image
                            {...image3}
                            height={1440}
                            width={960} />
                    )}
                    {caption3 && (
                        <figcaption className='pt3 sm-hide'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption3}}/>
                        </figcaption>
                    )}
                </figure>
                <figure
                    className={`col-12 flex flex-wrap flex-grow ${video4 ? 'sm-width-min-content' : 'sm-width-auto'} mb4 sm-mb3`}
                    ref={image4Ref}>
                    {video4 ? (
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className='height-100 width-100 object-cover'
                            src={video4.videoUrl}/>
                    ) : (
                        <Image
                            {...image4}
                            height={1440}
                            width={960}  />
                    )}
                    {caption4 && (
                        <figcaption className='pt3 sm-hide'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption4}}/>
                        </figcaption>
                    )}
                </figure>
            </div>
            <div className='hide sm-show'>
                <div className='flex col-12'>
                    <figcaption
                        className={'flex flex-grow mb4 sm-mb0 sm-mr5 md-mr6'}
                        style={{width: image1Ref.current?.offsetWidth}}>
                        {caption1 && (
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption1}}/>
                        )}
                    </figcaption>
                    <figcaption
                        className={'flex flex-grow mb4 sm-mb0 sm-mr5 md-mr6'}
                        style={{width: image2Ref.current?.offsetWidth}}>
                        {caption2 && (
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption2}}/>
                        )}
                    </figcaption>
                    <figcaption
                        className={'flex flex-grow mb4 sm-mb0 sm-mr5 md-mr6'}
                        style={{width: image3Ref.current?.offsetWidth}}>
                        {caption3 && (
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption3}}/>
                        )}
                    </figcaption>
                    <figcaption
                        className={'flex flex-grow mb4 sm-mb0'}
                        style={{width: image4Ref.current?.offsetWidth}}>
                        {caption4 && (
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption4}}/>
                        )}
                    </figcaption>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default FourImages;
